import { View } from 'backbone';
import util from 'util/Util.js';
import _template from 'properties/table/column-main-misc.ejs';
import undoService from 'UndoService.js';
import textConstants        from 'TextConstants';

class MainMiscView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');


        this.events = {
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;        
        const oldPropVal = this.columnModel.get(propName);
        this.columnModel.set(propName,propVal);
        this.render();

        undoService.add({
            undo: () => {
                this.columnModel.set(propName, oldPropVal, {silent: true});
                this.render();
            },
            redo: () => {
                this.columnModel.set(propName, propVal, {silent: true});
                this.render();
            }
        }, textConstants.UNDO_PROP_CHANGE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let newWindow = util.isTrue(this.columnModel.get('newWindow'));

        $(":checkbox[name='newWindow']").prop('checked', newWindow);

        let showError = util.isTrue(this.columnModel.get('showError'));

        $(":checkbox[name='showError']").prop('checked', showError);

        this.delegateEvents();
        return this;
    }

}

export default MainMiscView;
